export default __webpack_public_path__ + "static/careers-3-0fd9e1d251a9c470c7c460207ef13f1d.svg";